import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getBandeja } from "@/lib/staffApi";
import { Loader2, Clock, AlertTriangle, ChevronRight } from "lucide-react";

const PERFIL_COLOR = {
  Premium: "text-emerald-400", Excelente: "text-emerald-400",
  Bueno: "text-sky-400", Inicial: "text-amber-400",
};

export default function AsesorBandeja() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getBandeja().then(setData).catch(() => setData({ items: [] })).finally(() => setLoading(false));
  }, []);

  if (loading)
    return <div className="flex items-center gap-2 text-neutral-400"><Loader2 className="animate-spin" /> Cargando bandeja…</div>;

  const items = data?.items || [];

  return (
    <div data-testid="asesor-bandeja">
      <h1 className="text-2xl font-bold mb-1">Bandeja de trámites</h1>
      <p className="text-sm text-neutral-500 mb-6">{items.length} trámite(s) · orden: contado → perfil → tiempo</p>
      {items.length === 0 && (
        <div className="text-neutral-500 bg-[#111] border border-neutral-800 rounded-xl p-8 text-center">
          No tienes trámites asignados por el momento.
        </div>
      )}
      <div className="space-y-3">
        {items.map((t) => (
          <button key={t.tramite_id} onClick={() => navigate(`/staff/expediente/${t.tramite_id}`)}
            data-testid={`bandeja-item-${t.tramite_id}`}
            className="w-full text-left bg-[#111] hover:bg-[#161616] border border-neutral-800 rounded-xl p-4 flex items-center justify-between transition-colors">
            <div className="flex items-center gap-4">
              <div>
                <div className="flex items-center gap-2">
                  <span className="font-mono text-xs text-neutral-500">{t.folio}</span>
                  {t.es_contado && (
                    <span className="text-[10px] font-bold uppercase bg-orange-500/20 text-orange-400 px-2 py-0.5 rounded">Contado</span>
                  )}
                </div>
                <div className="font-semibold mt-0.5">{t.nombre || "Sin nombre"}</div>
                <div className="text-sm text-neutral-500">
                  {t.modalidad} · <span className={PERFIL_COLOR[t.perfil] || "text-neutral-400"}>{t.perfil || "—"}</span>
                </div>
              </div>
            </div>
            <div className="flex items-center gap-5">
              <div className="text-right">
                <div className="text-xs text-neutral-500 flex items-center gap-1 justify-end">
                  <Clock size={12} /> {t.minutos != null ? `${t.minutos} min` : "—"}
                </div>
                {t.sla_vencido && (
                  <div className="text-xs text-red-400 flex items-center gap-1 justify-end mt-1" data-testid={`sla-vencido-${t.tramite_id}`}>
                    <AlertTriangle size={12} /> SLA vencido
                  </div>
                )}
                {!t.sla_vencido && t.sla_limite && (
                  <div className="text-xs text-emerald-400 mt-1">SLA {t.sla_limite} min</div>
                )}
              </div>
              <ChevronRight className="text-neutral-600" />
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
